import React, { useState } from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { NotificationMessage } from './NotificationMessage';
import { ConfirmModal } from './ConfirmModal';

export const OrderInvoice = ({ invoice, index, orderId, handleCancelChange, handleReplaceChange }) => {
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [nota, setNota] = useState('');
    const [loading, setLoading] = useState(false);
    const [isNotaInvalid, setIsNotaInvalid] = useState(false);

    const [notification, setNotification] = useState({
        type: 'info',
        message: '',
        show: false,
    });

    const types = {
        sell: 'Venda',
        supplier: 'Fornecedor'
    };

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const openCancelModal = () => {
        setIsCancelModalOpen(true);
    };

    const closeCancelModal = () => {
        setIsCancelModalOpen(false);
    };
    
    const confirmCancelChange = () => {
        handleCancelChange();
    };

    const HandleInvoiceChange = async () => {
        setLoading(true);

        if (!nota) {
          setIsNotaInvalid(true);
          setLoading(false);
          return;
        }

        setIsNotaInvalid(false);

        try {
            const response = await fetch(`${baseUrl}/orders/${orderId}/invoices/fetch?invoiceId=${nota}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (response.ok) {
                setLoading(false);
                handleReplaceChange();
            } else {
                setNotification({
                    type: 'error',
                    message: 'Erro ao enviar nova nota. Verifique os dados inseridos.',
                    show: true,
                });

                setLoading(false);
                console.error('Erro ao enviar nova nota:', response.statusText);
            }
        } catch (error) {
            setLoading(false);
            console.error("Erro ao enviar nova nota:", error);
        }
    };

    const handleCloseNotification = () => {
        setNotification((prev) => ({ ...prev, show: false }));
    };

    return (
        <tr key={index} className={`${index > 0 ? 'border-t' : ''}`}>
            <td className="py-2 px-4 max-w-96">
                <div className="flex justify-between items-center">
                    <div className={`${invoice.status === 'canceled' ? 'opacity-60' : ''}`}>
                        <p className="leading-snug 2xl:leading-normal"><span className="font-bold">Número:</span> {invoice.number} <span className="ml-4 font-bold">Série:</span> {invoice.series} <span className="ml-4 font-bold">Tipo:</span> {types[invoice.type]}</p>
                        <p className="leading-snug 2xl:leading-normal"><span className="font-bold">Chave:</span> {invoice.access_key}</p>
                        <p className="leading-snug 2xl:leading-normal"><span className="font-bold">Emissão:</span> {invoice.created_at} <span className="ml-4 font-bold">Status:</span> <span className={`ml-1 px-1 pb-0.5 rounded${invoice.status === 'canceled' ? ' text-white' : ''}`} style={{ backgroundColor: invoice.status_color }}>{invoice.translated_status}</span></p>
                    </div>

                    {invoice.status === 'issued' ? (
                        <div className="flex gap-x-4">
                            {invoice.xml && (
                                <a href={invoice.xml} download={`nota-${invoice.number}.xml`} target="_blank" title="Exportar XML">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1536 1504" width="30" height="30" className="fill-green-800 transition-all duration-300 hover:fill-green-600">
                                        <g>
                                            <polygon points="1152,32 1152,224 1312,224 1312,288 1120,288 1088,288 1088,256 1088,32" />
                                            <path d="M259.6,0H1120h13.2l9.4,9.4l224,224l9.4,9.4V256v800v32h-32H224h-32v-32V67.6c0-18.6,7.6-35.5,19.8-47.7C224,7.6,240.9,0,259.6,0L259.6,0z M1106.8,64H259.6c-0.9,0-1.8,0.4-2.5,1.1c-0.7,0.7-1.1,1.5-1.1,2.5V1024h1056V269.2L1106.8,64L1106.8,64z" />
                                            <path d="M1512.1,1048.1c-14.8-14.9-35.1-24.1-57.5-24.1H81.4v0c-22.4,0-42.7,9.2-57.5,24.1C9.1,1062.9,0,1083.3,0,1105.7v316.5c0,22.4,9.1,42.8,23.9,57.6c14.8,14.9,35.1,24.1,57.5,24.1h1373.2c22.4,0,42.7-9.2,57.5-24.1c14.7-14.8,23.9-35.2,23.9-57.6v-316.5C1536,1083.3,1526.9,1062.9,1512.1,1048.1z M523.6,1418.9L453,1308.7l-70.9,110.2h-77.2l0,0v0h0l108.9-166.3l-98.7-152.4h75.2l64,102.4l62.5-102.4h74.6L492.3,1255l108.9,163.9H523.6z M941.1,1418.9h-59.7V1168l-63.3,250.8h-61.9L693.1,1168v250.8h-59.7v0l0,0h0v-318.6h96.3l57.8,217.4l57.1-217.4h96.5V1418.9z M1231.1,1418.9h-224.3v-316.1h64.3v262.3h160V1418.9z" />
                                            
                                            <g>
                                                <polygon points="873,887.2 873,887.2 873,887.2" />
                                                <polygon points="1194.4,628.4 1055.6,540.4 1055.4,540.4 931.2,461.6 929.6,462.6 873,498.4 931.3,535.4 931.3,535.2 1026.4,595.6 1026.4,595.6 1078.2,628.4 1121.7,656 1026.5,716.4 1026.5,716.4 931.3,776.7 931.3,776.7 873,813.7 911.9,838.3 912,838.3 931.1,850.4 1055.4,771.6 1194.3,683.6 1194.3,683.6 1237.9,655.9" />
                                            </g>

                                            <g>
                                                <polygon points="695,424.8 695,424.8 695,424.8" />
                                                <polygon points="373.6,683.6 512.4,771.6 512.6,771.6 636.8,850.4 638.4,849.4 695,813.6 636.7,776.6 636.7,776.8 541.6,716.4 541.6,716.4 489.8,683.6 446.3,656 541.5,595.6 541.5,595.6 636.7,535.3 636.7,535.3 695,498.3 656.1,473.7 656,473.7 636.9,461.6 512.6,540.4 373.7,628.4 373.7,628.4 330.1,656.1" />
                                            </g>

                                            <polygon points="696.6,884.9 815.2,410.2 871.4,427.1 752.8,901.9" />
                                        </g>
                                    </svg>
                                </a>
                            )}

                            {invoice.pdf && (
                                <a href={invoice.pdf} target="_blank" title="Exportar PDF">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1536 1504" width="30" height="30" className="fill-red-800 transition-all duration-300 hover:fill-red-600">
                                        <g>
                                            <polygon points="1152,32 1152,224 1312,224 1312,288 1120,288 1088,288 1088,256 1088,32" />
                                            <path d="M259.6,0H1120h13.2l9.4,9.4l224,224l9.4,9.4V256v800v32h-32H224h-32v-32V67.6c0-18.6,7.6-35.5,19.8-47.7C224,7.6,240.9,0,259.6,0L259.6,0z M1106.8,64H259.6c-0.9,0-1.8,0.4-2.5,1.1c-0.7,0.7-1.1,1.5-1.1,2.5V1024h1056V269.2L1106.8,64L1106.8,64z" />
                                            <polygon points="774.6,512 1152,512 1152,576 774.6,576" />
                                            <polygon points="774.6,736 1152,736 1152,800 774.6,800" />
                                            <path d="M640,576v160H480V576H640 M704,512H416v288h288V512L704,512z" />

                                            <g>
                                                <path d="M502.7,1156.3c-7.7-1.5-23.1-2.2-46.3-2.2h-31.1l0,0v90.4h35.2c25.4,0,42.4-1.6,50.9-5c8.5-3.3,15.2-8.5,20.1-15.7c4.8-7.1,7.3-15.4,7.3-24.8c0-11.6-3.4-21.1-10.2-28.7C521.7,1162.9,513.1,1158.2,502.7,1156.3z" />
                                                <path d="M833.5,1172.2c-7.9-7.4-17.8-12.4-29.8-15c-9-2.1-26.6-3-52.8-3H722l0,0v211h48c18,0,30.9-1,39-3c10.4-2.6,19.1-7,26-13.2c6.9-6.2,12.5-16.5,16.8-30.8c4.3-14.2,6.5-33.8,6.5-58.4c0-24.6-2.2-43.5-6.5-56.7C847.4,1189.8,841.3,1179.5,833.5,1172.2z" />
                                                <path d="M1512.1,1048.1c-14.8-14.9-35.1-24.1-57.5-24.1H81.4v0c-22.4,0-42.7,9.2-57.5,24.1C9.1,1062.9,0,1083.3,0,1105.7v316.5c0,22.4,9.1,42.8,23.9,57.6c14.8,14.9,35.1,24.1,57.5,24.1h1373.2c22.4,0,42.7-9.2,57.5-24.1c14.7-14.8,23.9-35.2,23.9-57.6v-316.5C1536,1083.3,1526.9,1062.9,1512.1,1048.1z M594.4,1247.6c-7.1,13.4-16.1,23.8-27.1,31.5c-10.9,7.6-22,12.6-33.3,15.1c-15.4,3-37.6,4.6-66.8,4.6h-41.9v120.2H361h0v-318.6h103.2c39.1,0,64.6,1.6,76.5,4.8c18.3,4.7,33.6,15.1,45.9,31.2c12.3,16,18.5,36.7,18.5,62C605,1217.8,601.5,1234.3,594.4,1247.6z M914.9,1330.4c-7.9,23.1-19.3,41.9-34.1,56.2c-11.1,10.9-26.2,19.4-45.2,25.4c-14.2,4.5-33.2,6.8-57,6.8h-121v-318.6h0h117.6c26.5,0,46.7,2,60.6,6.1c18.7,5.5,34.7,15.3,48,29.4c13.4,14,23.5,31.2,30.5,51.6c6.9,20.4,10.4,45.5,10.4,75.4C924.7,1288.8,921.5,1311.4,914.9,1330.4z M1198.2,1154.2h-154.1v75.4h133v53.9h-133v135.4h-64.4v0l0,0h0v-318.6h218.5V1154.2z" />
                                            </g>
                                        </g>
                                    </svg>
                                </a>
                            )}

                            <a onClick={openCancelModal} title="Cancelar Nota" className="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0 0 128 128" className="group">
                                    <path className="fill-red-600 transition-all duration-300 group-hover:fill-red-400" d="M64 24A40 40 0 1 0 64 104A40 40 0 1 0 64 24Z" transform="rotate(-45.001 64 64.001)"></path>
                                    <path className="fill-red-950 transition-all duration-300 group-hover:fill-red-800" d="M64,122c-15.5,0-30.1-6-41-17C12,94.1,6,79.5,6,64s6-30.1,17-41c11-11,25.5-17,41-17s30.1,6,41,17l0,0l0,0 c11,11,17,25.5,17,41s-6,30.1-17,41C94.1,116,79.5,122,64,122z M64,12c-13.9,0-26.9,5.4-36.8,15.2S12,50.1,12,64 s5.4,26.9,15.2,36.8S50.1,116,64,116s26.9-5.4,36.8-15.2S116,77.9,116,64s-5.4-26.9-15.2-36.8l0,0C90.9,17.4,77.9,12,64,12z"></path><path fill="#fff" d="M68.2,64l11.3-11.3c1.2-1.2,1.2-3.1,0-4.2c-1.2-1.2-3.1-1.2-4.2,0L64,59.8L52.7,48.4c-1.2-1.2-3.1-1.2-4.2,0 c-1.2,1.2-1.2,3.1,0,4.2L59.8,64L48.4,75.3c-1.2,1.2-1.2,3.1,0,4.2c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9L64,68.2l11.3,11.3 c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9c1.2-1.2,1.2-3.1,0-4.2L68.2,64z"></path>
                                </svg>
                            </a>
                        </div>
                    ) : (
                        invoice.type === 'sell' && (
                            <div className="-mt-5">
                                <label 
                                    htmlFor="nota" 
                                    className="text-sm font-medium text-gray-700 mb-1"
                                >
                                    Importar nova nota
                                </label>

                                <div className="max-w-52 w-full flex">
                                    <input
                                        type="text"
                                        name="nota"
                                        value={nota}
                                        onChange={(e) => setNota(e.target.value)}
                                        className={`w-full px-3 py-2 w-full border rounded-l-md ${
                                          isNotaInvalid ? 'border-red-500' : 'border-gray-300'
                                        }`}
                                        placeholder="Nº nova nota"
                                        required
                                    />

                                    <a
                                        onClick={HandleInvoiceChange} 
                                        className={`flex items-center justify-center cursor-pointer bg-slate-600 border border-slate-600 text-white py-2 w-full max-w-10 rounded-r-md transition-colors duration-300 mr-2 hover:bg-opacity-90`}
                                        >
                                        <span>
                                            {loading ? (
                                                <svg
                                                    aria-hidden="true"
                                                    className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white"
                                                    viewBox="0 0 100 101" 
                                                    width="15"
                                                    height="15"xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    version="1.1"
                                                    viewBox="0 0 1280 1280"
                                                    width="15"
                                                    height="15"
                                                    aria-hidden="true"
                                                    className="fill-white"
                                                >
                                                    <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                                                        <path d="M480.2,6.9c16,3,2759,1370,6096,3038c5803,2901,6069,3036,6110,3082c56,63,98,154,106,229c13,121-39,260-125,336 c-35,31-1508,771-6106,3070c-5849,2924-6062,3029-6126,3035c-172,15-325-75-403-237c-28-59-31-73-30-160c0-79,5-104,26-150 c13-30,894-1359,1956-2953l1932-2897l-1932-2897c-1062-1594-1943-2923-1957-2953c-21-47-25-70-25-150c0-86,3-101,30-160 C115.2,64.9,282.2-22.1,480.2,6.9z" />
                                                    </g>
                                                </svg>
                                            )}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        )
                    )}
                </div>

                {isCancelModalOpen && <ConfirmModal icon={faTimes} closeModal={closeCancelModal} type="cancelInvoice" confirm={`/orders/${orderId}/invoices/${invoice.id}/cancel`} confirmCancelChange={confirmCancelChange} />}


                {notification && notification.show && <NotificationMessage type={notification.type} message={notification.message} show={notification.show} onClose={handleCloseNotification} />}
            </td>
        </tr>
    );
};
